jQuery(document).ready(function ($) {

  // Helper: add/remove .is-disabled on prev/next buttons
function bindNavState($slider, $prev, $next) {
  $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    var i = typeof currentSlide === 'undefined' ? 0 : currentSlide;

    var visible = slick.options.slidesToShow;
    var total = slick.slideCount;

    // last possible index
    var lastIndex = total - visible;
    if (lastIndex < 0) lastIndex = 0;

    // RESET
    $prev.removeClass('is-disabled').show();
    $next.removeClass('is-disabled').show();

    // 🔥 Hide both arrows if navigation is not needed
    if (total <= visible) {
      $prev.hide();
      $next.hide();
      return;
    }

    // FIRST SLIDE → disable prev
    if (i === 0) {
      $prev.addClass('is-disabled');
    }

    // LAST SLIDE → disable next
    if (i >= lastIndex) {
      $next.addClass('is-disabled');
    }
  });
}

  /* ------------------------------------
   * 1) .featured-collections .featured-single
   * ------------------------------------ */
  var $featuredSingle = $(".featured-collections .featured-single");
  var $fsPrev = $(".custom-featured-collections .ap-nextap-buttonprev-prev");
  var $fsNext = $(".custom-featured-collections .ap-nextap-buttonprev-next");

  bindNavState($featuredSingle, $fsPrev, $fsNext);

  $featuredSingle.slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false
  });

  // custom buttons → slider
  $(document).on("click", ".custom-featured-collections .ap-nextap-buttonprev-next", function () {
    $featuredSingle.slick("slickNext");
  });

  $(document).on("click", ".custom-featured-collections .ap-nextap-buttonprev-prev", function () {
    $featuredSingle.slick("slickPrev");
  });


  /* ------------------------------------
   * 2) .featured-collections .slick-slider-main
   * ------------------------------------ */
  var $mainSlider = $(".most-popular .slick-slider-main");
  var $mainPrev = $(".most-popular .ap-nextap-buttonprev-prev");
  var $mainNext = $(".most-popular .ap-nextap-buttonprev-next");

  bindNavState($mainSlider, $mainPrev, $mainNext);

  $mainSlider.slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(document).on("click", ".most-popular .ap-nextap-buttonprev-next", function () {
    $mainSlider.slick("slickNext");
  });

  $(document).on("click", ".most-popular .ap-nextap-buttonprev-prev", function () {
    $mainSlider.slick("slickPrev");
  });


  /* ------------------------------------
   * 3) .ap-logolist--carousel .ap-logolist--slider
   * ------------------------------------ */
  var $logoSlider = $(".ap-logolist--carousel .ap-logolist--slider");
  var $logoPrev = $(".ap-logolist--carousel .ap-nextap-buttonprev-prev");
  var $logoNext = $(".ap-logolist--carousel .ap-nextap-buttonprev-next");

  bindNavState($logoSlider, $logoPrev, $logoNext);

  $logoSlider.slick({
    slidesToShow: 8,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $(document).on("click", ".ap-logolist--carousel .ap-nextap-buttonprev-next", function () {
    $logoSlider.slick("slickNext");
  });

  $(document).on("click", ".ap-logolist--carousel .ap-nextap-buttonprev-prev", function () {
    $logoSlider.slick("slickPrev");
  });

    /* ------------------------------------
   * 4) ap-listarticle-slider
   * ------------------------------------ */
  var $articleSlider = $(".ap-listarticle-slider");
  var $articlePrev = $(".ap-listarticle--section .ap-nextap-buttonprev-prev");
  var $articleNext = $(".ap-listarticle--section .ap-nextap-buttonprev-next");

  bindNavState($articleSlider, $articlePrev, $articleNext);

    $articleSlider.slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(document).on("click", ".ap-listarticle--section .ap-nextap-buttonprev-next", function () {
    $articleSlider.slick("slickNext");
  });

  $(document).on("click", ".ap-listarticle--section .ap-nextap-buttonprev-prev", function () {
    $articleSlider.slick("slickPrev");
  });

/* ------------------------------------
 * 5) ap-highlights__slider (VIDEO)
 * - Desktop: play on hover, stop on leave
 * - Mobile: play only on active slide, stop others
 * ------------------------------------ */

var $highlightsSlider = $(".ap-highlights__slider");
var $highlightsPrev   = $(".ap-highlights .ap-nextap-buttonprev-prev");
var $highlightsNext   = $(".ap-highlights .ap-nextap-buttonprev-next");

bindNavState($highlightsSlider, $highlightsPrev, $highlightsNext);

function apIsTouchLike() {
  return window.matchMedia("(hover: none), (pointer: coarse)").matches;
}

function apStopVideo(videoEl) {
  if (!videoEl) return;
  try {
    videoEl.pause();
    videoEl.currentTime = 0;
  } catch (e) {}
}

function apPlayVideo(videoEl) {
  if (!videoEl) return;
  try {
    videoEl.muted = true;
    videoEl.playsInline = true;
    var p = videoEl.play();
    if (p && typeof p.catch === "function") p.catch(function () {});
  } catch (e) {}
}

function apStopAllHighlightVideos() {
  $highlightsSlider.find("video.ap-highlights__video").each(function () {
    apStopVideo(this);
  });
}

function apPlayActiveHighlightVideo() {
  apStopAllHighlightVideos();

  // Play only the current/active slide video
  var $current = $highlightsSlider.find(".slick-slide.slick-active");
  var videoEl = $current.find("video.ap-highlights__video").get(0);

  apPlayVideo(videoEl);
}

/* Bind slick events BEFORE initializing slick */
$highlightsSlider.on("init reInit afterChange", function () {
  // bindNavState already listens to init/reInit/afterChange,
  // so we do NOT call bindNavState() again here.

  if (apIsTouchLike()) {
    apPlayActiveHighlightVideo();
  } else {
    apStopAllHighlightVideos();
  }
});

/* Init Slick */
$highlightsSlider.slick({
  slidesToShow: 3.15,
  infinite: false,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  arrows: false,
  responsive: [
    {
      breakpoint: 999,
      settings: { slidesToShow: 2.15 }
    },
    {
      breakpoint: 767,
      settings: { slidesToShow: 1.2 }
    }
  ]
});

/* Custom nav buttons → slider (delegated like your old code) */
$(document).on("click", ".ap-highlights .ap-nextap-buttonprev-next", function () {
  if ($(this).hasClass("is-disabled")) return;
  $highlightsSlider.slick("slickNext");
});

$(document).on("click", ".ap-highlights .ap-nextap-buttonprev-prev", function () {
  if ($(this).hasClass("is-disabled")) return;
  $highlightsSlider.slick("slickPrev");
});

/* Desktop hover play (delegated so it works with slick clones) */
$highlightsSlider.on("mouseenter", ".ap-highlights__slide", function () {
  console.log('HERE');
  if (apIsTouchLike()) return;

  apStopAllHighlightVideos();
  var videoEl = $(this).find("video.ap-highlights__video").get(0);
  apPlayVideo(videoEl);
});

$highlightsSlider.on("mouseleave", ".ap-highlights__slide", function () {
  if (apIsTouchLike()) return;

  var videoEl = $(this).find("video.ap-highlights__video").get(0);
  apStopVideo(videoEl);
});

/* Optional: on resize/orientation change */
$(window).on("resize orientationchange", function () {
  if (!$highlightsSlider.hasClass("slick-initialized")) return;

  if (apIsTouchLike()) apPlayActiveHighlightVideo();
  else apStopAllHighlightVideos();
});





}); 







// ready
